import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalDirective} from 'ngx-bootstrap';
import {EndpointsService} from '../../../services/endpoints.service';
import {HttpApiService} from '../../../services/http-api.service';
import {ProfilesService} from '../../../services/profiles.service';
import {SharedService} from '../../../services/shared.service';
import {UserService} from '../../../services/user.service';
import {DomSanitizer} from '@angular/platform-browser';
import {URLSearchParams} from '@angular/http';
import {AlertMessageComponent, AlertType} from '../../../shared/alert-message/alert-message.component';

@Component({
  selector: 'app-list-quotations',
  templateUrl: './list-quotations.component.html'
})
export class ListQuotationsComponent implements OnInit {
  @ViewChild('childModal') public childModal: ModalDirective;
  @ViewChild('quoteModal') public quoteModal: ModalDirective;
  selectedEmail;
  selectTabQuotation: boolean;
  RFQs: Array<any> = [];
  quotations: Array<any> = [];
  quoteId = '';
  isViewOnly = false;
  rfqStatus = true;
  newRfq = false;
  isRequestForRFQ = true;
  rfqComponentDisplay = false;
  pendingRFQCount: number;
  approvedRFQCount: number;
  private selectedItem;
  searchStatus = 'PENDING';
  infoMessage = '';
  dataSource = null;
  uploadItem: any;
  rfqMessage: any;
  removeData = {rfqId: '', messageOwner: '', isRemovedFile: true, messageId: '', requestType: ''};
  editRFQ: any;
  isUpdating = false;
  rfqType: string;
  addQuote = false;
  selectedQuote;
  selectedRFQ;
  showAllRFQ = false;
  isCommercePlatFormSelected = true;
  selectionType = '';
  constructor(private endpoints: EndpointsService,
              private profileService: ProfilesService,
              private sharedService: SharedService,
              private router: Router,
              private Api: HttpApiService,
              private userService: UserService,
              private sanitizer: DomSanitizer,
              private activatedRoute: ActivatedRoute) {

   //this.onInit();
  }

  onInit() {
    const self = this;
    setTimeout(function () {
      this.selectionType = self.sharedService.rfq;
      self.getRFQs(self.sharedService.rfq);
      self.getQuotations();
    }, 1000);
  }
  ngOnInit() {
    const self = this;
    this.childModal.onHide.subscribe(function (modal) {
      self.selectedItem = null;
      self.selectedEmail = null;
    });
    this.sharedService.rfqSubject.subscribe((value) => {
      this.selectionType = value['requestType'];
      if (value['requestType'] == 'rfq') {
        this.rfqComponentDisplay = false;
        this.isCommercePlatFormSelected = value['isSelected'];
        if (this.isCommercePlatFormSelected) {
          this.quoteModal.hide();
        }
        this.rfqStatus = true;
        this.showAllRFQ = true;
        this.getRFQs('rfq');
      } else if (value['requestType'] == 'buyerRfq') {
        this.isCommercePlatFormSelected = value['isSelected'];
        if (this.isCommercePlatFormSelected) {
          this.quoteModal.hide();
        }
        this.rfqComponentDisplay = false;
        this.rfqStatus = true;
        this.showAllRFQ = true;
        this.getRFQs('buyerRfq');
      }
    });
  }

  getRFQs(rfqType) {
    this.rfqType = rfqType
    this.isUpdating = true;
    let url = this.endpoints.getResellerRFQListUrl();
    if (rfqType != '') {
      url += '?status=' + rfqType;
    }
    this.Api.get(url, true)
      .subscribe(response => {
        const self = this;
        this.pendingRFQCount = response.filter(item => item.status === 'PENDING').length;
        this.approvedRFQCount = response.filter(item => item.status === 'APPROVED').length;
        response.forEach(function (item) {
          /*Sending Email After RFQ Review to Buyer*/
          if (self.showAllRFQ) {
            self.sendEmail(self, item);
            const tempProfile = self.profileService.getProfileById(item.applicationProfile.id);
            item.applicationProfile = tempProfile ? tempProfile : item.applicationProfile;
            if (!item.applicationProfile) {
              item.applicationProfile = {};
            } else {
              item.vendorApprovalRequired = item.applicationProfile.vendorApprovalRequired;
            }
          }
        });
        this.RFQs = this.searchStatus === 'ALL' ? response : response.filter(item => item.status === this.searchStatus);
        this.isUpdating = false;
      }, error => {
        this.isUpdating = false;
      });
  }

  sendEmail(self, item) {
    const data = self.activatedRoute.queryParams._value;
    if (!self.isCommercePlatFormSelected &&
      ((item.quotation && data.quotation == item.quotation.displayId) ||
        (item.buyerQuotation && data.quotation == item.buyerQuotation.displayId)) &&
      data.rfqViewId == item.id) {

      self.selectedQuote = item.quotation ? item.quotation : item.buyerQuotation;
      self.showQuoteModal(item, data.reference);
    }
    if (!self.isCommercePlatFormSelected && data.rfqViewId == item.id && !data.quotation) {
      if ((this.sharedService.getParameter('rfqViewId') !== data.rfqViewId)) {
        let user = '';
        if (self.userService.isReseller()) {
          user = 'reseller';
        } else if (self.userService.isVendor()) {
          user = 'vendor';
        }
        if (user !== '' && !(data.isEditable)) {
          this.Api.post(this.endpoints.getSendEmailUrl(),
            {'rfqViewId': data.rfqViewId, 'userType': user}, true)
            .subscribe(emailResponse => {
              console.log(emailResponse);
            });
        }
        this.sharedService.setParameter('rfqViewId', data.rfqViewId);
      }
      self.editQuoteData(item);
    }
  }

  getQuotations() {
    this.isUpdating = true;
    this.Api.get(this.endpoints.getResellerQuotationListUrl(), true)
      .subscribe(response => {
        this.quotations = response;
        this.isUpdating = false;
      }, error => {
        this.isUpdating = false;
      });
  }

  editQuote(item: any) {
    const rfq: any = this.RFQs.filter(rfq => rfq.id === item.rfq.id);
    this.sharedService.setParameter('selectedRFQ', rfq[0]);
    this.sharedService.setParameter('selectedQuote', item);
    this.router.navigateByUrl('/reseller/quotation');
  }

  public showSuggestModal(item) {
    this.selectedItem = item;
    this.selectedEmail = item.buyerEmail;
    this.childModal.show();
    return false;
  }

  public hideSuggestModal() {
    this.selectedItem = null;
    this.selectedEmail = null;
    this.childModal.hide();
    return false;
  }

  public userCreated(e) {
    const self = this;
    this.RFQs.forEach(function (rfq) {
      if (rfq.buyerEmail === self.selectedItem.buyerEmail) {
        rfq.buyer = 'not-null';
      }
    });
  }

  setSharedParameter(key, value) {
    this.sharedService.setParameter(key, value);
  }

  createResellerRFQ(requestForQuote) {
    this.sharedService.setParameter('selectedRFQ', requestForQuote);
    this.router.navigateByUrl('/request-for-quotation?rfqId=' + requestForQuote.id);
  }

  createNewResellerRFQ() {
    this.router.navigateByUrl('/request-for-quotation');
  }

  editQuoteData(quoteItem) {
    this.quoteId = quoteItem.id;
    this.isViewOnly = true;
    this.rfqStatus = false;
    this.newRfq = false;
    this.isRequestForRFQ = true;
    this.sharedService.setParameter('selectedRFQ', quoteItem);
    this.sharedService.setParameter('editMode', true);
    this.rfqComponentDisplay = true;
  }

  setRfqStatus(event) {
    this.rfqStatus = event;
    this.rfqComponentDisplay = false;
    this.getRFQs('rfq');
  }

  editReferenceQuote(quoteReference) {
    const self = this;
    self.RFQs.forEach(function (item) {
      if (item.requestNo === quoteReference) {
        self.editQuoteData(item);
        return;
      }
    });
  }

  setSource(item) {
    this.infoMessage = item.text;
    if (item.infoDocUrl && item.infoDocUrl != '') {
      this.dataSource = this.sanitizer.bypassSecurityTrustResourceUrl(item.infoDocUrl);
    }
  }

  setMessages(item) {
    this.rfqMessage = item;
  }

  deleteAttachment(data, message) {
    this.isUpdating = true;
    this.removeData.rfqId = data.id;
    if (this.userService.isVendor()) {
      this.removeData.messageOwner = 'VENDOR';
    } else if (this.userService.isReseller()) {
      this.removeData.messageOwner = 'RESELLER';
    }else if (this.userService.isBuyer()) {
      this.removeData.messageOwner = 'BUYER';
    }
    this.removeData.requestType = 'RFQ';
    this.removeData.isRemovedFile = true;
    this.removeData.messageId = message.id;
    this.Api.post(this.endpoints.getLeadUrl() + '/upload-information', this.removeData, true)
      .subscribe(result => {
        let index = -1;
        if (this.userService.isVendor()) {
          index = data.messagesFromVendor.indexOf(message);
          if (index >= 0) {
            data.messagesFromVendor.splice(index, 1);
          }
        } else if (this.userService.isReseller()) {
          index = data.messagesFromReseller.indexOf(message);
          if (index >= 0) {
            data.messagesFromReseller.splice(index, 1);
          }
        }
        this.setMessages(data);
        this.isUpdating = false;
        AlertMessageComponent.open(AlertType.Success, 'Message Deleted Successfully');
        console.log(result);
      }, er => {
        this.isUpdating = false;
        AlertMessageComponent.open(AlertType.Error, 'Message Deletion Failure');
      });
  }

  showQuoteModal(rfq, quoteReference) {
    if (this.selectedQuote) {
      this.isUpdating = true;
      this.Api.get(this.endpoints.getQuoteUrl() + '/' + this.selectedQuote.id, true).subscribe(
        res => {
          this.selectedQuote = res;
          this.selectedQuote.requestForQuotation = rfq;
          this.selectedQuote.reference = quoteReference;
          this.isUpdating = false;
          this.quoteModal.config.backdrop = false;
          this.quoteModal.show();
          this.quoteModal.config.ignoreBackdropClick = true;

        }, error => {
          this.isUpdating = false;
        }
      );
      this.selectedQuote.requestForQuotation = rfq;
    } else {
      this.selectedQuote = {message: '', displayId: '', requestForQuotation: rfq, reference: quoteReference};
      this.quoteModal.config.backdrop = false;
      this.quoteModal.show();
      this.quoteModal.config.ignoreBackdropClick = true;
    }
  }

  hideQuoteModal() {
    this.quoteModal.hide();
    this.isCommercePlatFormSelected = true;
  }

  updateRFQ(value) {
    this.selectedQuote = {}
    this.quoteModal.hide();
    this.searchStatus = 'ALL';
    this.getRFQs(this.selectionType);
  }

  forwardRequestToVendor(rfq) {
    this.isUpdating = true;
    rfq.isQuoteForVendor = !rfq.isQuoteForVendor;
    this.Api.put(this.endpoints.getRequestForQuoteUrl() + '/' + rfq.id, rfq, true).subscribe(
      res => {
        this.isUpdating = false;
      }, error => {
        this.isUpdating = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/list-quotations/list-quotations.component.ts